import { IDestroyable } from '../../common';
import { IPageInner } from '../page';

/**
 * 区域状态：
 * 默认状态
 * 选中状态
 * 多选状态
 * 激活状态
 */
export enum RegionState {
  default, selected, multiSelected, activated
}

export interface IRegion extends IDestroyable {
  $element: JQuery;
  page: IPageInner;

  addChild(child: any);

  updateTheme(theme: string);

}
